import { useEffect, useState } from "react";
import "./ClientePedidos.css";
import { useNavigate, NavLink } from "react-router-dom";
import SeguimientoDevolucion from "../../Componentes/SeguimientoDevolucion/SeguimientoDevolucion";
  const API = process.env.REACT_APP_API_URL


export default function ClientePedidos() {
  const navigate = useNavigate();
  const [pedidos, setPedidos] = useState([]);
  const [devoluciones, setDevoluciones] = useState({});
  const [loading, setLoading] = useState(true);


  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "null");

  useEffect(() => {
    if (!user) { navigate("/login"); return; }
    cargarPedidos();
  }, []);


  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch( API + "/user/refresh",{
         method:"POST",
          credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        window.location.reload();
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const cargarPedidos = async () => {
    try {
      const response = await fetch(
        `${API}/pedido/traerPedidosUsuario/${user.id}`,
        { headers: { Authorization: `Bearer ${token}`}
     
      }
      );

      if(response.status === 403 && await renovarToken())return;
      const data = await response.json();
      setPedidos(data.datos || []);
    } catch (error) {
      console.error("Error cargando pedidos", error);
    } finally {
      setLoading(false);
    }
  };
const traerDevolucion = async (pedidoId) => {
  // NO uses la variable 'token' de afuera, búscala aquí adentro siempre:
  const tokenParaEstaPeticion = localStorage.getItem("token");

  try {
    const response = await fetch(`${API}/devolucion/traerDevolucionPedidos/${pedidoId}`, {
      headers: { 
        "Authorization": `Bearer ${tokenParaEstaPeticion}`,

      }
    });

    if (response.status === 401 || response.status === 403) {
      console.log("Token vencido pidiendo devolución. Renovando...");
      const renovado = await renovarToken();
      if (renovado) {
        // MUY IMPORTANTE: Recursividad para reintentar con el nuevo token
        return traerDevolucion(pedidoId); 
      }
      return;
    }

    const data = await response.json();
    if (data.datos) {
      setDevoluciones(prev => ({ 
        ...prev, 
        [pedidoId]: prev[pedidoId] ? null : data.datos 
      }));
    } else {
      navigate(`/SolicitudDevoluciones/${pedidoId}`);
    }
  } catch (error) {
    console.error("Error crítico:", error);
  }
};

  return (
    <div className="pedidos-layout">
      <div className="container-pedidos">
        
        <header className="header-seccion">
          <NavLink to="/PerfilUser" className="link-volver">← Mi Perfil</NavLink>
          <h1 className="main-title">Mis Compras 📦</h1>
          <p>Rastrea el estado de tus productos y gestiona devoluciones.</p>
        </header>

        {loading ? (
          <div className="spinner-center">Cargando historial...</div>
        ) : (
          <div className="lista-wrapper">
            {pedidos.length === 0 ? (
              <div className="card-vacia">
                <span className="emoji-vacio">🛍️</span>
                <h3>No hay pedidos registrados</h3>
                <NavLink to="/" className="btn-comprar-ahora">Ir a la tienda</NavLink>
              </div>
            ) : (
              pedidos.map((pedido) => (
                <div className="pedido-container-card" key={pedido.id}>
                  
                  {/* Encabezado de la Tarjeta */}
                  <div className="card-header-top">
                    <span className="order-id">Pedido #{pedido.id}</span>
                    <span className={`badge-estado ${pedido.estado?.toLowerCase() || "entregado"}`}>
                      {pedido.estado?.replace("_", " ") || "ENTREGADO"}
                    </span>
                  </div>

                  {/* Cuerpo de la Tarjeta */}
                  <div className="card-main-content">
                    <div className="col-info">
                      <p className="txt-envio">
                        <strong>📍 Entrega en:</strong> {pedido.direccionEnvio}
                      </p>
                      <h3 className="txt-total">
                        Total: {pedido.total.toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                          minimumFractionDigits: 0,
                        })}
                      </h3>
                    </div>

                    <div className="col-productos">
                      <div className="productos-inner-box">
                        {pedido.detalles.map((det) => (
                          <div className="item-fila" key={det.id}>
                            <span className="item-nombre">{det.nombreProducto}</span>
                            <span className="item-qty">x{det.cantidad}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Pie de la Tarjeta */}
                  <div className="card-footer-actions">
                    <button 
                      className={`btn-gestion-dev ${devoluciones[pedido.id] ? 'btn-active' : ''}`} 
                      onClick={() => traerDevolucion(pedido.id)}
                    >
                      <span className="icon-btn">🔄</span> 
                      {devoluciones[pedido.id] ? "Ocultar Detalles" : "Gestionar Devolución"}
                    </button>
                  </div>

                  {/* Seguimiento Expandible */}
                  {devoluciones[pedido.id] && (
                    <div className="expand-section">
                      <SeguimientoDevolucion devolucion={devoluciones[pedido.id]} />
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}